import { Outlet, useMatch } from 'react-router';
import { AppSidebar, useViewer } from '@/features/session';
import { ROUTES } from '@/shared/config/routes';
import { cn } from '@/shared/lib/cn';

/** Signed-in pages: the sidebar and one main column (design: Main, Usage, Setup, FirstRun). */
export function AppLayout() {
  const { user, workspace } = useViewer();
  const isFirstRun = useMatch(ROUTES.GET_STARTED) !== null;
  if (!user || !workspace) return null;

  return (
    <div className="flex min-h-screen flex-wrap items-stretch bg-bg text-ink">
      <AppSidebar user={user} workspace={workspace} />
      <main
        className={cn(
          'flex min-w-0 shrink grow-999 basis-140 flex-col gap-5 px-4 pt-5 pb-10 shell:px-10 shell:pt-7 shell:pb-16',
          !isFirstRun && 'max-w-290',
        )}
      >
        <Outlet />
      </main>
    </div>
  );
}
